function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "210mm",
  height: "297mm",
  viewBox: "0 0 210 297",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2209 148h52v50h-52z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2209 148h52v50h-52z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2209 148h52v50h-52z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  transform: "translate(-12688.815 -847.516) scale(5.72442)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2241 170.253h-12c-1.11 0-2-.896-2-2s.89-2 2-2h12c1.11 0 2 .896 2 2s-.89 2-2 2zm0 8h-12c-1.11 0-2-.896-2-2s.89-2 2-2h12c1.11 0 2 .896 2 2s-.89 2-2 2zm0 8h-12c-1.11 0-2-.896-2-2s.89-2 2-2h12c1.11 0 2 .896 2 2s-.89 2-2 2zm-10-34h8v4h-8zm20 0h-8v-2c0-1.104-.89-2-2-2h-12c-1.11 0-2 .896-2 2v2h-8c-1.11 0-2 .896-2 2v40c0 1.104.89 2 2 2h32c1.11 0 2-.896 2-2v-40c0-1.104-.89-2-2-2z",
  fill: "#201041",
  fillRule: "evenodd"
}))))));